"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiPartnerCode = /** @class */ (function (_super) {
    __extends(ApiPartnerCode, _super);
    function ApiPartnerCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ADD_CATEGORY = "/api/partner/setCompany";
        _this.DELETE_CATEGORY = "/api/partner/delCompany";
        _this.ADD_CODE = "/api/partner/setPartnerCode";
        _this.DELETE_CODE = "/api/partner/delPartnerCode";
        _this.UPDATE_CODE = "/api/partner/updatePartnerCode";
        _this.DISUSE_CODE = "/api/partner/disusePartnerCode";
        _this.GET_CODE_CATEGORY = "/api/partner/main";
        _this.getCodeList = function (accesstoken, page, limit, searchKeyword) {
            var data = {
                partnerCodePage: page,
                partnerCodeLimit: limit,
                partnerCodeSearchKeyword: searchKeyword,
            };
            if (!searchKeyword || searchKeyword.length <= 0) {
                delete data.partnerCodeSearchKeyword;
            }
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_CODE_CATEGORY,
                data: data,
            });
            return config;
        };
        _this.createCodeItem = function (accesstoken, partnerCompanyId, partnerId, partnerDescription) {
            var data = {
                partnerCompanyId: partnerCompanyId,
                partnerId: partnerId,
                partnerDescription: partnerDescription,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.ADD_CODE,
                data: data,
            });
            return config;
        };
        _this.setCodeItem = function (accesstoken, id, partnerCompanyId, partnerId, partnerDescription) {
            var data = {
                id: id,
                partnerCompanyId: partnerCompanyId,
                partnerId: partnerId,
                partnerDescription: partnerDescription,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_CODE,
                data: data,
            });
            return config;
        };
        _this.pauseCodeItem = function (accesstoken, id) {
            var data = {
                id: id,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DISUSE_CODE,
                data: data,
            });
            return config;
        };
        _this.deleteCodeItem = function (accesstoken, id) {
            var data = {
                id: id,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_CODE,
                data: data,
            });
            return config;
        };
        _this.createCategoryItem = function (accesstoken, name, description) {
            var data = {
                name: name,
                description: description,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.ADD_CATEGORY,
                data: data,
            });
            return config;
        };
        _this.deleteCategoryItem = function (accesstoken, id) {
            var data = {
                id: id,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_CATEGORY,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiPartnerCode.getInstance = function (initValue) {
        if (!ApiPartnerCode.classInstance) {
            this.classInstance = new ApiPartnerCode(initValue);
        }
        return this.classInstance;
    };
    return ApiPartnerCode;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiPartnerCode;
